export function TranscriptSkeletonRow() {
    return (
        <>
            <div className="h-4 bg-muted rounded-lg" />
            <div className="flex flex-col gap-2">
                <div className="h-4 bg-muted rounded-lg" />
                <div className="h-4 bg-muted rounded-lg" />
                <div className="h-4 bg-muted rounded-lg" />
            </div>
        </>
    );
}
